import { collection, getDocs, addDoc, deleteDoc, doc, serverTimestamp, updateDoc, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase/config.js";

export async function addContactRequest(requestProps) {
    try {
        const docRef = await addDoc(collection(db, 'contactRequests'), {
            ...requestProps,
            status: 'pending',
            createdAt: serverTimestamp()
        });

        return { success: true };
    } catch (error) {
        console.error('Error adding request:', error);
        return { success: false, error: error.message };
    }
}

export async function getAllRequests() {
    try {
        const querySnapshot = await getDocs(collection(db, "contactRequests"));
        const allRequests = []
        querySnapshot.forEach((doc) => {
            allRequests.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, requests: allRequests };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function updateRequest(requestId, status) {
    try {
        const requestDocRef = doc(db, "contactRequests", requestId);

        await updateDoc(requestDocRef, {
            status: status,
            updatedAt: serverTimestamp()
        });

        return { success: true, requestId };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function deleteRequest(requestId) {
    try {
        await deleteDoc(doc(db, "contactRequests", requestId));
        return { success: true, requestId };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function getRequestsCount() {
    try {
        const coll = collection(db, "contactRequests");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count
        return { success: true, count };
    } catch (error) {
        console.error('Error getting count:', error);
        return { success: false, error: error.message };
    }
}